export const securitiesAccountsSelector = (state) => {
  const securitiesAccounts = state.userSecuritiesAccounts.data
    .filter((elem) => elem.visible === 'Y')
    .map((el) => {
      return {
        label: el.accountDescr,
        value: el.account,
        favorite: el.favorite,
      };
    });

  return securitiesAccounts;
};

// Selector to get if favorite securities account exists
export const selectFavoriteSecurityAccount = (state) => {
  if (state.userSecuritiesAccounts.data.length === 0) {
    return null;
  }

  const favorite = state.userSecuritiesAccounts.data.find(
    (el) => el.favorite === 'Y',
  );

  if (favorite) {
    const { account } = favorite;
    return account;
  }

  return null;
};

export const securityAccountSelectedSelector = (state) =>
  state.userSecuritiesAccounts.selectedAccount;

export const securityAccountSelectedInfoSelector = (state) => {
  // When entering the site, the selected account is not yet defined. That is why we return empty, when the account is selected the value is updated
  if (!state?.userSecuritiesAccounts?.selectedAccount) {
    return '';
  }

  return state.userSecuritiesAccounts.data.find(
    (el) => el.account === state.userSecuritiesAccounts.selectedAccount,
  );
};

export const securitiesAccountsFullSelector = (state) =>
  state.userSecuritiesAccounts.data;
